import React from 'react';
import { array, bool, func, node, shape, string } from 'prop-types';

import IconButton from '@material-ui/core/IconButton';
import Modal from '@material-ui/core/Modal';

import ActionErrorList from './ActionErrorList';
import modal from './EsmsModal.module.css';

const EsmsModal = ({
    children,
    classes,
    errors,
    onClose,
    imgSrc,
    open,
    onRendered,
    title
}) => {
    let figure = null;
    if (imgSrc) {
        figure = (
            <aside className={modal.figure}>
                <img alt="" src={imgSrc} />
            </aside>
        );
    }
    return (
        <Modal
            aria-labelledby="modal-title"
            open={open}
            onEscapeKeyDown={onClose}
            onRendered={onRendered}
            className="esmsModalContainer"
        >
            <div className={`${modal.root} ${classes.overrideMarginTop}`}>
                <header className={modal.header}>
                    <p id="modal-title">
                        {title}
                    </p>
                    <IconButton
                        aria-label="Close"
                        className={modal.closeButton}
                        color="inherit"
                        onClick={onClose}
                    >
                        <i className="fa fa-times" />
                    </IconButton>
                </header>
                <ActionErrorList errors={errors} />
                <div className={modal.body}>
                    {figure}
                    <section
                        className={`${modal.content} ${classes.bodyContent}`}
                    >
                        {children}
                    </section>
                </div>
            </div>
        </Modal>
    );
};

EsmsModal.defaultProps = {
    classes: {},
    errors:  [],
    title:   'Title Here'
};

EsmsModal.propTypes = {
    children: node,
    classes:  shape({
        bodyContent: string
    }),
    errors: array,
    open:   bool,
    render: func,
    title:  string
};

export default EsmsModal;
